<template>
  <div class="sfsdrrwer">
    <p class="sdfsdtye"></p>
    <div class="pr">
      <img src="@/assets/img/banner.jpg" class="banner w100" />
      <div class="kjnmxer2">
        <div class="bgff yj4 sgfyyw pd pm20">
          <p class="cen pt20">
            <img src="../assets/img/yyxz.png" class="cz fsgdywe" />
          </p>
          <div class="mt15">
            <p>
              <span class="fz16 cf jhbnxertr">开馆时间</span>
            </p>
            <p v-if="timeNotice" class="fz12 z3 mt10 jjseerrt" v-html="timeNotice"></p>
          </div>
          <div class="mt15">
            <p>
              <span class="fz16 cf jhbnxertr">预约须知</span>
            </p>
            <p v-if="orderNotice" class="fz12 z3 mt10 jjseerrt" v-html="orderNotice"></p>
          </div>
          <div class="mt15">
            <p>
              <span class="fz16 cf jhbnxertr">联系信息</span>
            </p>
            <p
              v-if="contactNotice"
              class="fz12 z3 mt10 jjseerrt"
              v-html="contactNotice"
            ></p>
          </div>
        </div>
        <div class="pd pt10 pm10 fz14" style="display: flex;align-items: center;" >
          <van-checkbox v-if="showDaojis" v-model="checked" icon-size="16px" checked-color="#845F56" :disabled="disabled">
            我已认真阅读预约须知、<a @click="onShowPrivacyPolicy" style="text-decoration: underline;">“隐私政策”</a>并同意
            <span v-if="daosji > 0 && showDaojis">({{daosji}}S)</span>
          </van-checkbox>          
        </div>
        <van-row v-if="groupOrderFlag" gutter="8" class="dsfstywer" :class="(!checked || daosji > 0) && showDaojis ? 'sdrtter' : ''">
          <!-- <van-col span="8">
            <img src="../assets/img/dsfsdfa.png" class=" buttonImg" @click="createOrder(false)" />
          </van-col> -->
          <van-col span="12">
            <img src="../assets/img/sanke1.png" class=" sanke1" @click="createOrder(true)" />
          </van-col>
          <van-col span="12">
            <img src="../assets/img/tuandui.png" class=" tuandui" @click="createGroupOrder"/>
          </van-col>
        </van-row>
        <van-row v-else gutter="8" class="dsfstywer" :class="(!checked || daosji > 0) && showDaojis ? 'sdrtter' : ''">
          <!-- <van-col span="12">
            <img src="../assets/img/dsfsdfa.png" class=" buttonImg" @click="createOrder(false)" />
          </van-col> -->
          <van-col span="24">
            <img src="../assets/img/sanke2.png" class=" sanke2" @click="createOrder(true)" />
          </van-col>
        </van-row>
      </div>
    </div>
    <van-dialog v-model="showNews" :showConfirmButton="false">
      <div class="pt10 pm10 pr cen cf" style="background: #a9716d;">
        <span class="cz ml10 fz17">公 告</span>
      </div>
      <div class="newDiv">
        <div class="content">
          <div v-if="autoPushNews.content" v-html="autoPushNews.content"></div>
        </div>
      </div>
      <div class=" pt10 pm10 btm cen"> 
        <van-button type="primary" class="w80" @click="showNews = false">已知晓</van-button>
      </div>
    </van-dialog>

    <van-dialog v-model="showPrivacyPolicy" :showConfirmButton="false">
      <div class="pt10 pm10 pr cen cf" style="background: #a9716d;">
        <span class="cz ml10 fz17">隐私政策</span>
      </div>
      <div class="newDiv">
        <div class="content">
          <div v-if="notice.privacyPolicy" v-html="notice.privacyPolicy"></div>
        </div>
      </div>
      <div class=" pt10 pm10 btm cen"> 
        <van-button type="primary" class="w80" @click="showPrivacyPolicy = false">已知晓</van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import appConsts from "@/store/consts.js";
import settingService from "./../services/settingService.js";
import scenicService from "./../services/scenicService.js";
import ticketTypeService from "./../services/ticketTypeService.js";
// import memberService  from "./../services/memberService.js";
var newsFlag= false;
export default {
  name: "home1",
  props: {
    groundName: {
      type: String
    }
  },
  data() {
    return {
      ticketTypeIds: "",
      clientWidth: 375,
      clientHeight: 667,
      checked: false,
      active: 0,
      daosji: 0,
      jjnjsd: 0,
      disabled: false,
      showDaojis: true,
      groupOrderFlag :false,
      showNews: false,
      showPrivacyPolicy: false,
      autoPushNews: {},
      timeNotice: "",
      orderNotice: "",
      contactNotice: "",
    };
  },
  computed: {
    contentWidth() {
      return this.clientWidth - 60;
    },
    contentHeight() {
      return this.clientHeight - 200;
    },
    ...mapState({
      member: (state) => state.memberModule.member,
      notice: (state) => state.homeModule.notice
    })
  },
  methods: {
    
    onShowPrivacyPolicy(){
      this.showPrivacyPolicy=true;
    },
    async createOrder(addChildren) {
      if (this.ticketTypeIds) {
          this.$router.replace({
            name: "createorder",
            params: { addChildren: addChildren , ticketTypeIds: this.ticketTypeIds},
          });
      }
    },
    async createGroupOrder() {
      if (this.ticketTypeIds) {
          if (this.member.isCustomerLogin) {
            this.$router.replace({
              name: "creategrouporder",
              params: { ticketTypeIds: this.ticketTypeIds }
            });
          } else {
            this.$router.replace({
              name: "grouplogin",
              params: { shouldBind: "0", nextPath: "creategrouporder", ticketTypeIds: this.ticketTypeIds}
            });
          }
      }
    },
    resize() {
      this.clientWidth = document.documentElement.clientWidth;
      this.clientHeight = document.documentElement.clientHeight;
    },
    ...mapMutations([
      "setTitle",
      "showNavbar",
      "setShowNavbarLeft",
      "setShowNavbarRight"
    ]),
    ...mapActions("homeModule", [appConsts.loadOrderNoticeAsync]),
    ...mapActions("memberModule", [appConsts.loadMemberAsync])
  },
  async created() {
    await this.loadOrderNoticeAsync();
    this.autoPushNews = {};    
    var newses = await scenicService.getNewsThemesAsync();
    if(newses && newses.length > 0) {
      var autoPushNews = newses.find(o => {
        return o.autoPushFlag == true;
      });
      if (newsFlag && autoPushNews) {
        autoPushNews.content = decodeURIComponent(autoPushNews.content);
        this.autoPushNews = autoPushNews;
        this.showNews = true;
      }
    }
    var groundIds="";
    var groundNames = window.groundNames;
    if(!groundNames){
      groundNames = {"海战博物馆及威远炮台":"2,4,5","虎门林则徐纪念馆":"1","沙角炮台":"3"};
    }    
    switch(this.groundName){
      case "5,6,7": //海战博物馆及威远炮台
          groundIds= groundNames["海战博物馆及威远炮台"];
          this.timeNotice = this.notice.timeNotice;
          this.orderNotice = this.notice.orderNotice;
          this.contactNotice = this.notice.contactNotice;
          break;
      case "3": //虎门林则徐纪念馆
          groundIds= groundNames["虎门林则徐纪念馆"];
          this.timeNotice = this.notice.timeNoticeForLinZexuMemorialHall;
          this.orderNotice = this.notice.orderNoticeForLinZexuMemorialHall;
          this.contactNotice = this.notice.contactNoticeForLinZexuMemorialHall;
          break;
      case "4": //沙角炮台
          groundIds= groundNames["沙角炮台"];
          this.timeNotice = this.notice.timeNoticeForShaJiaoBattery;
          this.orderNotice = this.notice.orderNoticeForShaJiaoBattery;
          this.contactNotice = this.notice.contactNoticeForShaJiaoBattery;
          break;
      default:
          groundIds= this.groundName;
    }
    this.ticketTypeIds = await ticketTypeService.getTicketTypeIdsByGroundIds(groundIds);
    //console.log( this.ticketTypeIds);
    const options = await settingService.getOptionsAsync();
    if (options && options.GroupOrderFlag && options.GroupOrderFlag == "1") {
      this.groupOrderFlag = true;
    }

    await this.loadMemberAsync();
    
    if(this.daosji <= 0){
      this.disabled = false;
    }
    this.setTitle(this.notice.scenicName);   
    if (this.showDaojis) {      
      let sdd = setInterval(() => {
        if (this.daosji-- <= 1) {
          clearTimeout(sdd);
          this.disabled = false;
        }
      }, 1000);
    }
  },
  async mounted() {
    this.resize();
    let vm = this;
    window.onresize = function () {
      vm.resize();
    };
    await this.loadOrderNoticeAsync();
    this.daosji = Number(this.notice.readTime);
    if (this.daosji < 0) {
      this.showDaojis = false;
    }
    if (this.daosji > 0) {
      this.disabled = true;
    }

    var u = navigator.userAgent;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (isIOS) {
      this.jjnjsd = window.screen.height - 400;
    } else {
      this.jjnjsd = window.screen.height - 360;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name == "login") {
        vm.setShowNavbarLeft(false);
        newsFlag = true;
      } else {
        newsFlag = false;
      }
      vm.setShowNavbarRight(false);
    });
  },
  beforeDestroy() {
    this.setShowNavbarLeft(true);
    this.setShowNavbarRight(true);
    window.onresize = null;
  }
};
</script>

<style scoped>
.sgfyyw {
  height: 100%;
}

.sdfsdtye {
  position: fixed;
  left: 0;
  top: 46;
  width: 100%;
  height: 100%;
}

.sfsdrrwer {
  bottom: 50px;
  height: calc(100vh - 50px);
  background: url("../assets/img/indexbg.jpg") no-repeat;
  background-color: #f3efd9;
  background-size: 100%;
  background-position: bottom;
}

.kjnmxer2 {
  z-index: 1000;
  position: fixed;
  left: 0;
  right: 0;
  margin-left: 10px;
  margin-right: 10px;
  height: calc(100vh - 250px);
  top: 100px;
}
.sdfsdttyw2 {
  position: fixed;
  left: 0;
  bottom: 60px;
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  height: 155px;
}
.fsgdywe {
  width: 200px;
}

.jhbnxertr {
  background: #a9716d;
  display: inline-block;
  width: 91px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-top-right-radius: 10px;
}

.jjseerrt {
  line-height: 18px;
}

.jjnnxeer {
  height: 48px;
  padding-top: 12px;
  padding-left: 10px;
  background: #53211d;
}

.jjhhjsa {
  width: 26px;
  height: 26px;
  background-position: -11px -23px;
}

.jjhhjsa.ab {
  width: 32px;
  background-position: -61px -23px;
}

.jjhhjsa.ac {
  width: 30px;
  background-position: -124px -23px;
}

.dfgdfy6 {
  line-height: 1.4;
  position: relative;
  top: -4px;
}
.dsfstywer {
  opacity: 0.7;
  text-align: center;
}
.sdrtter {
  pointer-events: none;
  opacity: 0.4;
}

.bannerDiv {
  height: 125px;
  width: 100%;
  background: url(../assets/img/banner.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
.buttonImg {
  width: 90px;
  height: 44px;
}
.sanke1 {
  width: 135px;
  height: 50px;
}
.sanke2 {
  width: calc(100vw - 50px);
}
.tuandui {
  width: 135px;
  height: 50px;
}
.content {
  margin-top: 10px;
  padding: 0 10px;
  padding-bottom: 10px;
  background-color: white;
}
.newDiv {
  max-height: calc(50vh);
  overflow-y: auto;
}
</style>
